﻿import { FIQAssist } from "../app";
import "@fiqas/utils"
import { Component, Input, Output, Inject, Attribute } from "@fiqas/angular-utils";
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils";

@Component({
    module: FIQAssist,
    selector: 'datetimebox',
    template: `<table class="datetimebox {{$ctrl.childClasses}} ng-class:{'has-value':$ctrl.hasValue}" id="{{'datetime_'+$id}}"
                    uib-tooltip="{{$ctrl.tooltipText}}" tooltip-is-open="$ctrl.tooltipShow" tooltip-placement="bottom" tooltip-class="customTooltipTB">
                <tr>
                    <td class="entry">
                        <input tabindex="0" type="text" min-date="$ctrl.minDate" max-date="$ctrl.maxDate"
                            class="form-control" uib-datepicker-popup="{{$ctrl.format}}" is-open="$ctrl.opened" datepicker-options="$ctrl.datepickeroptions"
                            show-button-bar="false" datepicker-append-to-body="false" popup-placement="{{$ctrl.popupPlacement}}" close-text="{{'Close' | translate}}"
                            ng-focus="$ctrl.onFocus($event)" ng-blur="$ctrl.onBlur($event)" ng-keydown="$ctrl.onKeyDown($event)"
                            ng-readonly="$ctrl.readOnly" validate-min-date="$ctrl.minDate" validate-max-date="$ctrl.maxDate" datepicker-append-to-body="true"
                            ng-model="$ctrl.internalDate" ng-maxlength="$ctrl.format.length" datepicker-popup-template-url="views/datepicker.popup.html" datepicker-template-url="views/datepicker.html"
                        />
                        <span class="mandatory-dot ng-class:{'has-value':$ctrl.hasValue}" ng-if="$ctrl.mandatory" uib-tooltip="{{'FIELD_REQUIRED_TOOLTIP' | translate}}" tooltip-placement="bottom" tooltip-class="customTooltipTB"></span>
                        <span class="icon-clearField ng-class:{'has-value':$ctrl._date}" ng-show="$ctrl.showClear" ng-click="$ctrl.ClearField($event)"></span>
                    </td>
                    <td class="icon ng-class:{'readonly':$ctrl.readOnly}"><span ng-click="$ctrl.open($event)" class="icon-calendar"><span class="path1"><span class="path2"><span class="path3"><span class="path4"><span class="path5"><span class="path6"><span class="path7"><span class="path8"><span class="path9"><span class="path10"><span class="path11"></span></span></span></span></span></span></span></span></span></span></span></span></td>
                </tr>
            </table>`
})
export class DateTimeBox {
    private isInitialized: boolean = false;
    private _date: Date;
    private format: string = "dd-MM-yyyy";
    private formats: string[] = ['dd-MM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    private altInputFormats: string[] = ['M!/d!/yyyy'];
    private isFocus: boolean;
    private wasFocused = false;
    private datepickeroptions;
    private tooltipShow: boolean;

    @Input() public readOnly: boolean;
    @Input() public daysOfWeekDisabledMessage;
    private get tooltipText() {
        return this.tooltipShow ? this.daysOfWeekDisabledMessage : "";
    }

    private _popupPlacement: string = "bottom";
    @Attribute()
    public get popupPlacement() {
        return this._popupPlacement;
    }
    public set popupPlacement(value: string) {
        if (value !== undefined) {
            this._popupPlacement = value;
        }
    }

    constructor(
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService,
        @Inject("$scope") private $scope: angular.IScope,
        @Inject('uibDateParser') private dateParser: any,
        @Inject('$timeout') private $timeout: angular.ITimeoutService
    ) {
    }

    private get hasValue() {
        return this._date !== null && this._date !== undefined;
    }
    private get showError() {
        return this.mandatory && ((!this.isFocus && this.wasFocused && !this.hasValue) || (!this.isFocus && this.iserror));
    }

    private _childClasses;
    @Attribute() public get childClasses() {
        return this._childClasses;
    }
    public set childClasses(val: string) {
        this._childClasses = val;
    }

    private _mandatory;
    @Attribute() public get mandatory() {
        return this._mandatory;
    }
    public set mandatory(val: boolean | string) {
        this._mandatory = val === true || val === "true";
    }
    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }
    private ClearField($event: BaseJQueryEventObject) {
        this.internalDate = null;
        $event.preventDefault();
        $event.stopPropagation();
    }
    private get dateString(): ISODateTimeString {
        if (this.date)
            return this.date.toISODateTimeString();
        else
            return undefined;
    }
    private set dateString(val: ISODateTimeString) {
        this.date = undefined;
        try {
            var d = this.dateParser.parse(val);
            this.date = d;
        } catch (e) {
            //not a valid date
        }
    }

    @Input() public hint: any = null;

    public $onInit() {
        this.isInitialized = true;
        this.datepickeroptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false,
            minDate: this.minDate,
            maxDate: this.maxDate,
            placement: this.popupPlacement,
            dateDisabled: (date) => this.disabledDate(date),
            datepickerMode: "day"
        };
    }

    private _daysOfWeekDisabled: number[];
    @Input()
    public get daysOfWeekDisabled(): number[] {
        return this._daysOfWeekDisabled;
    }
    public set daysOfWeekDisabled(value: number[]) {
        if (value == undefined) {
            this._daysOfWeekDisabled = [];
        } else if (value instanceof Array) {
            this._daysOfWeekDisabled = value;
        }
    }
    public disabledDate(data) {
        if (data.mode !== 'day' || this._daysOfWeekDisabled === undefined || this._daysOfWeekDisabled.length === 0)
            return false;
        return (this._daysOfWeekDisabled.some(v => v === data.date.getDay()));
    }

    @Input()
    public get minDate(): Date {
        return this._minDate;
    }
    public set minDate(value: Date) {
        this._minDate = value;
        if (this.datepickeroptions) {
            this.datepickeroptions.minDate = value;
        }
    }
    private _minDate: Date;

    @Input()
    public get maxDate(): Date {
        return this._maxDate;
    }
    public set maxDate(value: Date) {
        this._maxDate = value;
        if (this.datepickeroptions) {
            this.datepickeroptions.maxData = value;
        }
    }
    private _maxDate: Date;

    @Input()
    public get date(): Date {
        return this.isValid ? this.internalDate : null;
    }

    private get isValid() {
        var val = this.internalDate;
        if (val != null && this.minDate && this.minDate.getTime() > val.getTime() && (!this.rememberInitialValue || !this.initialValue || val.getTime() != this.initialValue.getTime()))
            return false;
        if (val != null && this.maxDate && this.maxDate.getTime() < val.getTime() && (!this.rememberInitialValue || !this.initialValue || val.getTime() != this.initialValue.getTime()))
            return false;
        return true;
    }

    public set date(val: Date) {
        this._date = val;
    }

    private get internalDate() {
        return this._date;
    }

    private set internalDate(val: Date) {
        if (this.isInitialized && this.initialValue === undefined && this.rememberInitialValue)
            this.initialValue = val || null;

        if (val && this._daysOfWeekDisabled !== undefined && this._daysOfWeekDisabled.length !== 0) {
            if (this._daysOfWeekDisabled.indexOf(val.getDay()) > -1) {
                this.tooltipShow = true;
                this.$timeout(() => this.tooltipShow = false, 4000);
            }
            while (this._daysOfWeekDisabled.some(v => v === val.getDay())) {
                val = val.addDays(1);
            }
        }

        var olddate = this.internalDate;
        this._date = val;
        var newdate = this.date;

        if (this.isInitialized && this.isValid && (
            (!newdate && olddate) ||
            (newdate && !olddate) ||
            (olddate && newdate && olddate.getTime() != newdate.getTime())
        ))
            this.ondatechanged({ date: newdate });
    }

    private inputValue: string;
    private evaluateInput(val) {
        if (!val && val !== null || this.readOnly)
            return;
        if (val === null)
            this.internalDate = val;
        var now = Date.today();
        var d: any[] = val.split("-");
        d[1] = d[1] || (now.getMonth() + 1);
        d[2] = !d[2] ? now.getFullYear() : d[2].length == 1 ? "200" + d[2] : d[2].length == 2 ? "20" + d[2] : d[2];
        var date: Date = this.dateParser.parse(d.join("-"), "d!-M!-yyyy", now);
        if (date === undefined)
            return;
        if (!this.internalDate || this.internalDate.getTime() != date.getTime())
            this.internalDate = date;
    }

    @Input() public iserror: boolean;
    @Input() public rememberInitialValue: boolean;
    private initialValue: Date;

    @Output() public ondatechanged: (args: { date: Date }) => void;
    @Output() public boxopen: (args: {}) => void;
    @Output() public boxclose: (args: {}) => void;

    private _opened: boolean = false;
    public get opened(): boolean { return this._opened; }
    public set opened(val: boolean) { this._opened = val; val ? this.boxopen({}) : this.boxclose({}); }

    public open(event) {
        //event.stopPropagation();
        if (this.isEditable) {
            this.opened = !this.opened;
        }
    }

    public close() {
        if (this.opened) {
            this.opened = false;
        }
    }

    public onFocus(event) {
        this.wasFocused = this.isFocus = true;
    }

    public onBlur(event) {
        this.isFocus = false;
        this.evaluateInput(event.target ? event.target.value : "");
    }

    public today() {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        this.internalDate = today;
    }

    public get isEditable(): boolean {
        return !this.readOnly;
    }

    public onKeyDown(event: KeyboardEvent) {
        if (event.keyCode === 0) {
            switch (event.code) {
                case KeyboardEventCode.backspace:
                case KeyboardEventCode.leftArrow:
                case KeyboardEventCode.rightArrow:
                case KeyboardEventCode.delete:
                case KeyboardEventCode.n0: case KeyboardEventCode.numpad0:
                case KeyboardEventCode.n1: case KeyboardEventCode.numpad1:
                case KeyboardEventCode.n2: case KeyboardEventCode.numpad2:
                case KeyboardEventCode.n3: case KeyboardEventCode.numpad3:
                case KeyboardEventCode.n4: case KeyboardEventCode.numpad4:
                case KeyboardEventCode.n5: case KeyboardEventCode.numpad5:
                case KeyboardEventCode.n6: case KeyboardEventCode.numpad6:
                case KeyboardEventCode.n7: case KeyboardEventCode.numpad7:
                case KeyboardEventCode.n8: case KeyboardEventCode.numpad8:
                case KeyboardEventCode.n9: case KeyboardEventCode.numpad9:
                case KeyboardEventCode.dash:
                case KeyboardEventCode.forwardSlash:
                case KeyboardEventCode.subtract:
                case KeyboardEventCode.end:
                case KeyboardEventCode.home:
                    break;

                case KeyboardEventCode.a:
                case KeyboardEventCode.c:
                case KeyboardEventCode.v:
                case KeyboardEventCode.x:
                    if (!event.ctrlKey && !event.metaKey) {
                        event.preventDefault();
                    }
                    break;

                case KeyboardEventCode.tab:
                    if (this.isFocus && this.opened) {
                        this.opened = false;
                    }
                    break;

                case KeyboardEventCode.enter:
                    this.evaluateInput(event.target ? event.target['value'] : "");
                    break;

                case KeyboardEventCode.space:
                    this.evaluateInput(event.target ? event.target['value'] : "");
                default:
                    event.preventDefault();
                    break;
            }
        } else {
            switch (event.keyCode) {
                case KeyCodes.backspace:
                case KeyCodes.leftArrow:
                case KeyCodes.rightArrow:
                case KeyCodes.delete:
                case KeyCodes.n0: case KeyCodes.numpad0:
                case KeyCodes.n1: case KeyCodes.numpad1:
                case KeyCodes.n2: case KeyCodes.numpad2:
                case KeyCodes.n3: case KeyCodes.numpad3:
                case KeyCodes.n4: case KeyCodes.numpad4:
                case KeyCodes.n5: case KeyCodes.numpad5:
                case KeyCodes.n6: case KeyCodes.numpad6:
                case KeyCodes.n7: case KeyCodes.numpad7:
                case KeyCodes.n8: case KeyCodes.numpad8:
                case KeyCodes.n9: case KeyCodes.numpad9:
                case KeyCodes.dash:
                case KeyCodes.forwardSlash:
                case KeyCodes.subtract:
                case KeyCodes.end:
                case KeyCodes.home:
                    break;

                case KeyCodes.a:
                case KeyCodes.c:
                case KeyCodes.v:
                case KeyCodes.x:
                    if (!event.ctrlKey && !event.metaKey) {
                        event.preventDefault();
                    }
                    break;

                case KeyCodes.tab:
                    if (this.isFocus && this.opened) {
                        this.opened = false;
                    }
                    break;

                case KeyCodes.enter:
                    this.evaluateInput(event.target ? event.target['value'] : "");
                    break;

                case KeyCodes.space:
                    this.evaluateInput(event.target ? event.target['value'] : "");
                default:
                    event.preventDefault();
                    break;
            }
        }
        if (this.opened && !event.defaultPrevented) {
            this.opened = false;
        }
    }
}

